var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 44,
    viewBox: "0 0 67 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment logos/visa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.984826,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    fill: "#020A23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.984826,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    stroke: "#A5B9D8",
    strokeWidth: 0.312574
  }), /*#__PURE__*/React.createElement("path", {
    id: "Visa",
    d: "M33.2513 15.1166L30.2187 29.2922H26.5518L29.5848 15.1166H33.2513ZM48.6795 24.2699L50.6101 18.9464L51.721 24.2699H48.6795ZM52.7709 29.2922H56.1628L53.203 15.1166H50.0722C49.3687 15.1166 48.7751 15.5258 48.5108 16.1566L43.0093 29.2922H46.8602L47.6247 27.1754H52.3294L52.7709 29.2922ZM43.2004 24.6638C43.2161 20.9224 38.0264 20.7164 38.0623 19.0452C38.0731 18.5359 38.5581 17.9957 39.6174 17.8571C40.1437 17.7884 41.5906 17.7359 43.2336 18.4919L43.877 15.4859C42.9945 15.1655 41.8589 14.8573 40.4465 14.8573C36.8222 14.8573 34.2711 16.7843 34.2495 19.5436C34.2267 21.5842 36.0707 22.7229 37.4602 23.4013C38.8887 24.0962 39.3688 24.5413 39.3625 25.1627C39.3531 26.1143 38.2229 26.5334 37.1686 26.55C35.3245 26.5792 34.2545 26.0524 33.4016 25.6549L32.7371 28.761C33.5936 29.1545 35.1751 29.4964 36.8159 29.5139C40.6677 29.5139 43.1879 27.6106 43.2004 24.6638ZM28.0113 15.1166L22.0701 29.2922H18.1931L15.2696 17.9791C15.092 17.2823 14.9376 17.0275 14.3979 16.7336C13.5171 16.2558 12.0612 15.8067 10.7803 15.5285L10.8678 15.1166H17.1074C17.9024 15.1166 18.618 15.6461 18.7984 16.5618L20.3427 24.7652L24.1586 15.1166H28.0113Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fcbd6ed7ae7efa556e92f677e2bf7742.svg";
export { ForwardRef as ReactComponent };